import { render, staticRenderFns } from "./Finances.vue?vue&type=template&id=bb620be6&scoped=true&"
import script from "./Finances.vue?vue&type=script&lang=js&"
export * from "./Finances.vue?vue&type=script&lang=js&"
import style0 from "./Finances.vue?vue&type=style&index=0&id=bb620be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb620be6",
  null
  
)

export default component.exports